<script lang="ts">
    import { reviewsIconCollectionManagerContextToken } from "@apps/reviews/context_tokens";
    import ReviewsListInfoEntity from "@apps/reviews/entities/ReviewsListInfoEntity";
    import Icon from "@components_v2/Icon.svelte";
    import { getTypedContext } from "@lib/svelte-typed-context";
    import { createEventDispatcher } from "svelte";

    import Button from "@components/Buttons/Button.svelte";

    import ReviewsProgressBar from "../ReviewsProgressBar/ReviewsProgressBar.svelte";
    import AverageReviewsTooltip from "./ReviewsTooltip.svelte";

    export let averageReviewsRating = 0;
    export let ratesInfo: ReviewsListInfoEntity["ratesInfo"] = [];
    export let allReviewsCount = 0;
    export let showSeeAllReviewsButton = false;

    export let basedOnReviewsText: string;
    export let seeAllReviewsText = "See all reviews";

    const dispatch = createEventDispatcher();

    const handleGoToReviews = () => {
        dispatch("goToReviews");
    };

    const iconCollection$ = getTypedContext(
        reviewsIconCollectionManagerContextToken
    ).getIconCollection();
</script>

<AverageReviewsTooltip>
    <div class="gw-rv-average__review" slot="targetElement">
        <slot />
    </div>

    <div class="gw-rv-average__tooltip" slot="content">
        <div class="gw-rv-average__tooltip-header">
            <Icon class="gw-rv-avg-rating__star" title="star avg-rating icon">
                <svelte:component this={$iconCollection$?.filled} />
            </Icon>

            <strong>{averageReviewsRating}/5</strong>

            <span class="gw-rv-average__tooltip-text">
                {basedOnReviewsText}
            </span>
        </div>

        <ul
            class="gw-rv-average__tooltip-progress-bar gw-list-reset-default-styles"
        >
            {#each ratesInfo ? [...ratesInfo].reverse() : [] as review}
                <ReviewsProgressBar
                    {allReviewsCount}
                    reviewCount={review.countReview}
                    rate={review.rating}
                />
            {/each}
        </ul>
        {#if showSeeAllReviewsButton}
            <div class="gw-rv-average__tooltip-divider" />

            <div class="gw-rv-average__tooltip-btn-wrapper">
                <Button
                    variant="link"
                    ariaLabel="See all Reviews"
                    class="gw-rv-average__tooltip-btn"
                    size="large"
                    on:click={handleGoToReviews}
                >
                    {seeAllReviewsText}
                </Button>
            </div>
        {/if}
    </div>
</AverageReviewsTooltip>

<style lang="postcss">
    .gw-rv-average {
        &__review {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            gap: 0.5rem;
        }

        &__tooltip {
            display: flex;
            flex-direction: column;
            gap: 0.75em;
            padding: 1em 0;
            width: 21.0625em;
        }

        &__tooltip-progress-bar {
            display: flex;
            flex-direction: column;
            gap: 0.75em;
            padding: 0 1em;
        }

        &__tooltip-header {
            display: flex;
            align-items: end;
            gap: 1em;

            font-size: 1em;
            line-height: 1.25em;
            padding: 0 1em;
        }

        &__tooltip-divider {
            border-top: 0.063em solid rgba(0, 0, 0, 0.1);
            width: 100%;
            height: 0.063em;
        }

        &__tooltip-btn-wrapper {
            display: flex;
            justify-content: center;
        }
    }
</style>
